import CoveoSearch from "./CoveoSearch";

export default CoveoSearch;
